import React from 'react';
import { ExternalLink } from 'lucide-react';
import ActionLinkButton from '../ActionLinkButton/ActionLinkButton';

interface ExternalLinkButtonProps {
  text: string;
  href?: string;
  onClick?: () => void;
  disabled?: boolean;
  actionName?: string;
  variant?: 'default' | 'blue';
  className?: string;
  iconSize?: 'sm' | 'md' | 'lg';
}

const ExternalLinkButton: React.FC<ExternalLinkButtonProps> = ({
  text,
  href,
  onClick,
  disabled = false,
  actionName,
  variant = 'default',
  className = '',
  iconSize = 'sm',
}) => {
  const handleClick = () => {
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    } else if (onClick) {
      onClick();
    }
  };

  const sizeClasses = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
    lg: 'h-5 w-5',
  };

  return (
    <ActionLinkButton
      text={text}
      onClick={handleClick}
      disabled={disabled}
      actionName={actionName}
      variant={variant}
      className={className}
      icon={<ExternalLink className={sizeClasses[iconSize]} />}
    />
  );
};

export default ExternalLinkButton;

